import { Button, Div } from '@driftt/tide-core'
import React from 'react'

import './style.css'

const TransientBanner = ({ payload }) => {
  const { body, action } = payload

  return (
    <Div className="transient-banner">
      {body}
      <Button onClick={action.handler} type="tertiary">
        {action.title}
      </Button>
    </Div>
  )
}

export default TransientBanner
